<template>
  <div>
    <div class="kit__utils__heading">
      <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
    </div>
    <div class="card">
      <div class="card-body">
        <a-collapse v-model="activeKey">
          <a-collapse-panel  v-for="(item, index) in data" :key="`${index}`" :header="item.name">
            <b-list-group v-for="(itemMenu, indexMenu) in item.menu" :key="indexMenu">
              <b-list-group-item>{{itemMenu.menuAdminName}} <a-switch checked-children="เปิด" :disabled="getStatus(itemMenu.menuAdminStatus).code" un-checked-children="ปิด" default-checked v-model="itemMenu.status" :value="itemMenu.status" @change="onChange(itemMenu.menuAdminId,itemMenu.status)" /></b-list-group-item>
            </b-list-group>
          </a-collapse-panel>
        </a-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import apiClient from '@/services/api'
import useNoti from '@/services/plugin/notification'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      data: [],
      // disabled: true,
      activeKey: [],
    }
  },
  watch: {

  },
  methods: {
    async getMangeRoleAdmin() {
      await apiClient.get(`/roleAdmin/mangeMenu/${this.$route.params.id}`, {}).then(response => {
        const res = response.data
        if (res.code === '000') {
          const DataRoleAdmin = res.responseData.data
          this.data = DataRoleAdmin
          for (let i = 0; i < this.data.length; i++) {
            this.activeKey.push(i)
          }
        }
      }).catch(err => {
        useNoti('error', 'Error', err.message)
      })
    },
    onChange(menuId, checked) {
      const sentData = {
        menuAdminID: menuId,
        status: checked,
      }
      if (menuId) {
        apiClient.put(`/roleAdmin/updateMenuAdmin/${this.$route.params.id}`, sentData).then(response => {
          if (response.status === 200) {
            useNoti('success', 'Success', response.data.message)
            this.getMangeRoleAdmin()
          } else {
            useNoti('error', 'Error', response.data.message)
          }
        }).catch(error => {
          Swal.showValidationMessage(
            `เกิดข้อผิดพลาด: ${error}`,
          )
        })
      }
    },

    getStatus(status) {
      const disabled = [
        {
          code: !this.disabled,
        }]
      const undisabled = [
        {
          code: this.disabled,
        },
      ]
      return status === 0 ? disabled[0] : undisabled[0]
    },
  },
  async created() {
    await this.getMangeRoleAdmin()
  },
}
</script>
<style></style>
